import * as React from "react";
import { Link } from "react-router";
import formatMoney from "/src/helpers/formatMoney";
import { CartIcon } from "/src/helpers/components/upsellIcons.jsx";

// Floating basket pill (prototype checkout.jsx BasketBar): navy, bottom-right, cart with an
// orange count badge, items/total stack and a white "View basket & checkout" button. On mobile
// it spans the bottom edge with a 12px inset.
export default function BasketBar({ basket }) {
    const count = (basket?.excursions?.length || 0) + (basket?.car ? 1 : 0);
    if (count === 0) return null;
    return (
        <div className="fixed z-40 left-3 right-3 bottom-3 md:left-auto md:right-6 md:bottom-6
                        flex items-center gap-3 md:gap-4 bg-emp_deep text-white
                        py-3 pl-4 pr-3 md:pl-[18px] md:pr-3.5 rounded-[14px] shadow-[0_14px_36px_rgba(8,53,92,0.34)]">
            <span className="relative inline-flex shrink-0">
                <CartIcon />
                <span className="absolute -top-[7px] -right-2 bg-orange text-white text-[11px] font-bold
                                 min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1">
                    {count}
                </span>
            </span>
            {/* The price must never be clipped or overlapped: it keeps its full width and the
                button is what gives way on narrow phones (its label wraps to two lines). */}
            <div className="leading-tight flex-1 md:flex-none shrink-0">
                <div className="text-xs opacity-80">{count} {count === 1 ? "item" : "items"}</div>
                <div className="text-[17px] font-bold whitespace-nowrap">£{formatMoney(basket?.estimatedTotal || 0)}</div>
            </div>
            <Link to="/checkout"
                  className="shrink min-w-0 md:shrink-0 px-3.5 md:px-[18px] py-2.5 rounded-btn bg-white text-emp_deep font-bold text-sm
                             text-center leading-snug md:whitespace-nowrap hover:bg-emp_soft">
                View basket &amp; checkout
            </Link>
        </div>
    );
}
